import image1 from "../assets/Home/IMG (38).png";
import image2 from "../assets/Home/IMG (1).png";
import image3 from "../assets/Home/IMG (2).png";
import image4 from "../assets/Home/IMG (3).png";
import image5 from "../assets/IMG (39).png";
import image6 from "../assets/IMG (40).png";
import image7 from "../assets/Home/IMG (6).png";
import image8 from "../assets/Home/IMG (7).png";

import image10 from "../assets/IMG (14).png";
import image11 from "../assets/HCards/IMG (8).png"; 
import image12 from "../assets/HCards/IMG (10).png";
import image13 from "../assets/HCards/IMG (12).png";
import image14 from "../assets/HCards/IMG (13).png";

import image21 from "../assets/HCards/IMG (16).png";
import image22 from "../assets/HCards/IMG (17).png";
import image23 from "../assets/HCards/IMG (18).png";
import image24 from "../assets/HCards/IMG (19).png";

import image111 from "../assets/HCards/Group 755.png";
import image112 from "../assets/HCards/Group 755 (1).png";
import image113 from "../assets/HCards/Group 755 (2).png";
import image114 from "../assets/HCards/Group 755 (3).png";

import { HiPlus } from "react-icons/hi2";
import { AiFillMinusCircle } from "react-icons/ai";

import { FaMedal } from "react-icons/fa6";
import { FaLock } from "react-icons/fa";
import { BsEyeFill } from "react-icons/bs";
import { FaPeopleLine } from "react-icons/fa6";

import { TfiHeadphoneAlt } from "react-icons/tfi";
import { MdLocalShipping } from "react-icons/md";
import { BsShieldFillCheck } from "react-icons/bs";

import mem1 from "../assets/About/Joshua.PNG";
import mem2 from "../assets/About/Mandy.PNG";
import mem3 from "../assets/About/Stephanie.PNG";
import mem4 from "../assets/About/Myrlene.PNG";
import mem5 from "../assets/About/Kelly.PNG";

import logo1 from "../assets/Logo/Frame.png";
import logo2 from "../assets/Logo/Frame (1).png";
import logo3 from "../assets/Logo/Frame (2).png";
import logo4 from "../assets/Logo/Frame (3).png";
import logo5 from "../assets/Logo/Frame (4).png";
import logo6 from "../assets/Logo/Frame (5).png";
import logo7 from "../assets/Logo/Frame (6).png";
import logo8 from "../assets/Logo/Frame (7).png";
import logo9 from "../assets/Logo/Frame (8).png";

// import client1 from "../assets/About/image (3).png";
// import client2 from "../assets/About/image (4).png";
import avatar from "../assets/About/testimonial-avatar.png";

import { PiUsersFill } from "react-icons/pi";
import { TiCreditCard } from "react-icons/ti";
import { FaFolderPlus } from "react-icons/fa";
import { BsCartFill } from "react-icons/bs";
// import { BsCartFill } from "react-icons/bs";
import { RiDiscountPercentFill } from "react-icons/ri";
import { FaWifi } from "react-icons/fa";
import boat from "../assets/Vehicle/boat.png";

import img1 from "../assets/Home/testimonials/img1.jpg"
import img2 from "../assets/Home/testimonials/img2.png"
import img3 from "../assets/Home/testimonials/img3.png"
import img4 from "../assets/Home/testimonials/img4.png"
import img5 from "../assets/Home/testimonials/img5.png"
import img6 from "../assets/Home/testimonials/img6.png"
import img7 from "../assets/Home/testimonials/img7.png"
import img8 from "../assets/Home/testimonials/img8.png"
import img9 from "../assets/Home/testimonials/img9.jpg"
import img10 from "../assets/Home/testimonials/img10.png"

export const archieved = [
  {
    img: image21,
    title: "2018 BMW X1 XDRIVE",
    lot: "38498458",
    vin: "WBHT3C3J3H",
    bid: "bid price",
    price: "$76500",
    view: "view history",
  },
  {
    img: image22,
    title: "2018 BMW X1 XDRIVE",
    lot: "38498458",
    vin: "WBHT3C3J3H",
    bid: "bid price",
    price: "$76500",
    view: "view history",
  },
  {
    img: image23,
    title: "2018 BMW X1 XDRIVE",
    lot: "38498458",
    vin: "WBHT3C3J3H",
    bid: "bid price",
    price: "$76500",
    view: "view history",
  },
  {
    img: image24,
    title: "2018 BMW X1 XDRIVE",
    lot: "38498458",
    vin: "WBHT3C3J3H",
    bid: "bid price",
    price: "$76500",
    view: "view history",
  },
  {
    img: image21,
    title: "2018 BMW X1 XDRIVE",
    lot: "38498458",
    vin: "WBHT3C3J3H",
    bid: "bid price",
    price: "$76500",
    view: "view history",
  },
  {
    img: image22,
    title: "2018 BMW X1 XDRIVE",
    lot: "38498458",
    vin: "WBHT3C3J3H",
    bid: "bid price",
    price: "$76500",
    view: "view history",
  },
  {
    img: image23,
    title: "2018 BMW X1 XDRIVE",
    lot: "38498458",
    vin: "WBHT3C3J3H",
    bid: "bid price",
    price: "$76500",
    view: "view history",
  },
  {
    img: image24,
    title: "2018 BMW X1 XDRIVE",
    lot: "38498458",
    vin: "WBHT3C3J3H",
    bid: "bid price",
    price: "$76500",
    view: "view history",
  },
];
export const Featured = [
  {
    img: image11,
    title: "2018 BMW X1 XDRIVE",
    lot: "38498458",
    vin: "WBHT3C3J3H",
    estimatedBid: "$3,690 - $6,510",
    potentialSavings: "$3,500",
  },
  {
    img: image12,
    title: "2018 BMW X1 XDRIVE",
    lot: "38498458",
    vin: "WBHT3C3J3H",
    estimatedBid: "$3,690 - $6,510",
    potentialSavings: "$3,500",
  },
  {
    img: image13,
    title: "2018 BMW X1 XDRIVE",
    lot: "38498458",
    vin: "WBHT3C3J3H",
    estimatedBid: "$3,690 - $6,510",
    potentialSavings: "$3,500",
  },
  {
    img: image14,
    title: "2018 BMW X1 XDRIVE",
    lot: "38498458",
    vin: "WBHT3C3J3H",
    estimatedBid: "$3,690 - $6,510",
    potentialSavings: "$3,500",
  },
  {
    img: image12,
    title: "2018 BMW X1 XDRIVE",
    lot: "38498458",
    vin: "WBHT3C3J3H",
    estimatedBid: "$3,690 - $6,510",
    potentialSavings: "$3,500",
  },
  {
    img: image13,
    title: "2018 BMW X1 XDRIVE",
    lot: "38498458",
    vin: "WBHT3C3J3H",
    estimatedBid: "$3,690 - $6,510",
    potentialSavings: "$3,500",
  },
  {
    img: image14,
    title: "2018 BMW X1 XDRIVE",
    lot: "38498458",
    vin: "WBHT3C3J3H",
    estimatedBid: "$3,690 - $6,510",
    potentialSavings: "$3,500",
  },
  // Add more items as needed
];

export const BUY = [
  {
    img1: image111,
    Car: "Hondai Sonata",
    img: image10,
    heading: "Creater",
    Name: "Salvadar dali",
    Bid: "Current Bid",
    Price: "$750",
    button: "Buy Now In 6,000$",
  },

  {
    img1: image112,
    Car: "Hondai Sonata",
    img: image10,
    heading: "Creater",
    Name: "Salvadar dali",
    Bid: "Current Bid",
    Price: "$750",
    button: "Buy Now In 6,000$",
  },
  {
    img1: image113,
    Car: "Hondai Sonata",
    img: image10,
    heading: "Creater",
    Name: "Salvadar dali",
    Bid: "Current Bid",
    Price: "$750",
    button: "Buy Now In 6,000$",
  },
  {
    img1: image114,
    Car: "Hondai Sonata",
    img: image10,
    heading: "Creater",
    Name: "Salvadar dali",
    Bid: "Current Bid",
    Price: "$750",
    button: "Buy Now In 6,000$",
  },
  {
    img1: image111,
    Car: "Hondai Sonata",
    img: image10,
    heading: "Creater",
    Name: "Salvadar dali",
    Bid: "Current Bid",
    Price: "$750",
    button: "Buy Now In 6,000$",
  },

  {
    img1: image112,
    Car: "Hondai Sonata",
    img: image10,
    heading: "Creater",
    Name: "Salvadar dali",
    Bid: "Current Bid",
    Price: "$750",
    button: "Buy Now In 6,000$",
  },
  {
    img1: image113,
    Car: "Hondai Sonata",
    img: image10,
    heading: "Creater",
    Name: "Salvadar dali",
    Bid: "Current Bid",
    Price: "$750",
    button: "Buy Now In 6,000$",
  },
];
export const live = [
  {
    img1: image111,
    Car: "Hondai Sonata",
    img: image10,
    heading: "Creater",
    Name: "Salvadar dali",
    Bid: "Current Bid",
    Price: "$750",
  },

  {
    img1: image112,
    Car: "Hondai Sonata",
    img: image10,
    heading: "Creater",
    Name: "Salvadar dali",
    Bid: "Current Bid",
    Price: "$750",
  },
  {
    img1: image113,
    Car: "Hondai Sonata",
    img: image10,
    heading: "Creater",
    Name: "Salvadar dali",
    Bid: "Current Bid",
    Price: "$750",
  },
  {
    img1: image114,
    Car: "Hondai Sonata",
    img: image10,
    heading: "Creater",
    Name: "Salvadar dali",
    Bid: "Current Bid",
    Price: "$750",
  },
  {
    img1: image111,
    Car: "Hondai Sonata",
    img: image10,
    heading: "Creater",
    Name: "Salvadar dali",
    Bid: "Current Bid",
    Price: "$750",
  },

  {
    img1: image112,
    Car: "Hondai Sonata",
    img: image10,
    heading: "Creater",
    Name: "Salvadar dali",
    Bid: "Current Bid",
    Price: "$750",
  },
  {
    img1: image113,
    Car: "Hondai Sonata",
    img: image10,
    heading: "Creater",
    Name: "Salvadar dali",
    Bid: "Current Bid",
    Price: "$750",
  },
];
export const categories = [
  { img: image1, category: "Automobiles",id:'Automobile' },
  { img: image2, category: "Super Car",id:'super-car' },
  { img: image3, category: "Motor Cycles",id:'Motorcycle' },
  { img: image4, category: "ATVs",id:'ATV' },
  { img: image5, category: "Buses",id:'Bus' },
  { img: image6, category: "Truck",id:'Truck' },
  { img: image7, category: "Trailer",id:'Trailers' },
  { img: image8, category: "Mobile Home",id:'Mobile Home' },
  { img: boat, category: "Boat",id:'Boat' },
];
export const values = [
  {
    icon: <FaMedal size={25} color="white" />,
    heading: "Customer-First Philosophy",
    para: "At BidCaribbean, a Lux First Choice Car Division, we are committed to understanding and fulfilling our customers' unique needs. From personalized solutions to hassle-free logistics, your satisfaction is our top priority.",
  },
  {
    icon: <FaLock size={25} color="white" />,
    heading: "Integrity in Every Interaction",
    para: "Transparency is the cornerstone of our business. With open, honest communication, we keep you informed every step of the way, ensuring complete confidence in every decision.",
  },
  {
    icon: <BsEyeFill size={25} color="white" />,
    heading: "Unmatched Value and Expertise",
    para: "At BidCaribbean, a Lux First Choice Car Division, we combine affordability with excellence, delivering tailored solutions to maximize quality and efficiency for every client. Whether you're looking for a luxury car or a practical solution, we’ve got you covered.",
  },
  {
    icon: <FaPeopleLine size={25} color="white" />,
    heading: "Innovative Growth and Excellence",
    para: "By embracing cutting-edge technologies and continuously refining our practices, we enhance your experience and set new industry standards.",
  },
];
export const choices = [
  {
    icon: (
      <MdLocalShipping
        size={25}
        color="white"
        className="absolute m-auto inset-0 "
      />
    ),
    heading: "Safe and Secured Auctions",
    para: "Our auctions are conducted in a secure and transparent environment, ensuring the safety of your investment. We use state-of-the-art technology to monitor and protect your assets, providing peace of mind for every transaction.",
  },
  {
    icon: (
      <TfiHeadphoneAlt
        size={25}
        color="white"
        className="absolute m-auto inset-0 "
      />
    ),
    heading: "Verified Vehicles You Can Trust",
    para: "We meticulously verify each vehicle to ensure its authenticity and quality. Our rigorous inspection process includes a comprehensive history check, ensuring that the vehicle is free from any issues and meets our high standards.",
  },
  {
    icon: (
      <BsShieldFillCheck
        size={25}
        color="white"
        className="absolute m-auto inset-0   "
      />
    ),
    heading: "Unbeatable Savings of 30-50%",
    para: "We offer vehicles at significantly lower prices than traditional dealerships, providing you with exceptional value and the opportunity to save big on your next car purchase.",
  },
  {
    icon: (
      <BsShieldFillCheck
        size={25}
        color="white"
        className="absolute m-auto inset-0   "
      />
    ),
    heading: "VIP Support At Every Step",
    para: "Our dedicated team is here to assist you every step of the way. From pre-auction preparation to post-delivery support, we ensure your experience is seamless and stress-free.",
  },
  {
    icon: (
      <BsShieldFillCheck
        size={25}
        color="white"
        className="absolute m-auto inset-0   "
      />
    ),
    heading: "Wide Selection of Over 140,000 Cars",
    para: "We offer a wide range of vehicles, from luxury sedans to rugged SUVs, ensuring you find the perfect fit for your needs.",
  },
];
export const process = [
  {
    heading: "Handpicked Selection",
    icon: <HiPlus size={30} color="red" />,
    p: "",
  },
  {
    heading: "Transparent Pricing",
    icon: <HiPlus size={30} color="red" />,
    p: "",
  },
  {
    heading: "Reliable Delivery",
    icon: <AiFillMinusCircle size={39} color="red" />,
    p: "We handle all logistics, from transportation to customs clearance, ensuring your vehicle arrives on time and in perfect condition.",
  },
  {
    heading: "Custumer support",
    icon: <HiPlus size={30} color="red" />,
    p: "",
  },
];
export const team = [
  {
    img: mem1, // Joshua Paul
    name: "Joshua Paul",
    title: "Founder & Chief Strategist",
  },
  {
    img: mem2,
    name: "Mandy",
    title: "Accounts & Finance Coordinator",
  },
  {
    img: mem3, // Stephanie
    name: "Stephanie",
    title: "Title & Documentation Specialist",
  },
  {
    img: mem4, // Myrlene
    name: "Myrlene",
    title: "Client Success Coordinator",
  },
  {
    img: mem5, // Kelly
    name: "Kelly",
    title: "Vehicle Consultant & Import Advisor",
  },
];
export const logos = [
  { logo: logo1 },
  { logo: logo2 },
  { logo: logo3 },
  { logo: logo4 },
  { logo: logo5 },
  { logo: logo6 },
  { logo: logo7 },
  { logo: logo8 },
  { logo: logo9 },
];
export const testi = [
  {
    para: "I saw an ad on facebook, decided to give them a try. Did contact them on whats app and responds was fast and quick. Was kept up dated all thru the process.",
    name: "judith mills",
    item: "Cam sensor",
    image: img2,
  },
  {
    para: `Friendly service, fast & reliable..
    For every question I had was answered very thoroughly in a kind professional manner..& would definitely be my first choice, they made the process a breeze! 👍🏾 …`,
    name: "Jade Thompson",
    item: "Acura Mdx",
    image: img3,
  },
  {
    para: "I recently imported with Lux First Choice Cars  and purchased a 2014 Honda Accord, They guided me through the entire process, ensuring a smooth outcome and the final landed fee was exactly as quoted, with no surprises. I received regular updates, and the vehicle was delivered right to my door. Their exceptional service made the whole experience stress-free. Highly recommend!",
    name: "Lashawn Huyler",
    item: "Honda Accord",
    image: img4,
  },
  {
    para: "Got a 2017 Altima from LUX FIRST CHOICE only thing I do is change the oil nothing else",
    name: "Damian Mitchell",
    item: "Nissan Altima",
    image: img6,
  },
  {
    para: "Very pleased with the service! The shipment did not take long and the service was impeccable! Company is very responsive and did a great job communicating on the status of my vehicle. Definitely recommend to anyone looking for a fast and reliable service.",
    name: "Quinneka Smith",
    item: "Nissan Leaf",
    image: img7,
  },
  {
    para: `I got exactly what I wanted at an unbelievable price. My 2023 Honda Pilot came drive ready with very low mileage and no front end damage as requested. It’s like I got a brand new car for half the price.  It’s a beauty. Everyone always asks: “ Do you want to sell it?”`,
    name: "Marina Johnson",
    item: "Honda pilot",
    image: img5,
  },

  {
    para: `Lux First Choice Cars offers one of the most professional services. The Agents were always courteous and kind. I highly recommend them to the general public.`,
    name: "Audrea Scavella ",
    item: "Subaru XV Crosstrek",
    image: img9,
  },

  {
    para: `My experience while dealing with LUX First Choice Cars was a very satisfied one. There's a friendly Staff that kept me up to date with my vehicle status on a weekly basis. I will definitely be using them in future. Awesome vehicle! Awesome service! Thank you, LUX!!`,
    name: "CoCo Max",
    item: "Nissan Rogue",
    image: img1,
  },

  {
    para: `Hi everyone looking to purchase a vehicle in this day and time this is my vehicle have recently purchased beautiful truck no delay no hassle no paperwork lux first choice cars I'm advising you if you need something done that's who you need to go with lux first choice no hassle no paperwork and the best part about it they were on time delivery was perfect.`,
    name: "Christine Fleurimond",
    item: "Nissan Frontier",
    image: img8,
  },
  {
    para: `It was a very pleasant and quick transaction! Everything went smoothly and I was kept up to date with everything! It really felt like I was apart of the team. Highly recommended.`,
    name: "Ro-Ann Burrows",
    item: "Kia Sorento",
    image: img10,
  },
];
export const feesLeftCard = [
  {
    heading: "no dealer license required",
    icon: <PiUsersFill size={25} className="mx-auto" />,
  },
  {
    heading: "no annual membership fee",
    icon: <TiCreditCard size={25} className="mx-auto" />,
  },
  {
    heading: "ability to search two auctions",
    icon: <FaWifi size={25} className="mx-auto" />,
  },
  {
    heading: "availability of full vehicle descriptions and details ",
    icon: <FaFolderPlus size={25} className="mx-auto" />,
  },
  {
    heading: "helps buyers avoid purchasing staged cars ",
    icon: <BsCartFill size={25} className="mx-auto" />,
  },
];
export const feesRightCard = [
  {
    heading: "requirement for a dealer/broker license",
    icon: <PiUsersFill size={25} className="mx-auto" />,
  },
  {
    heading: "annual membership fee at both sites",
    icon: <TiCreditCard size={25} className="mx-auto" />,
  },
  {
    heading: "separate deposits for each auction",
    icon: <FaWifi size={25} className="mx-auto" />,
  },
  {
    heading: "shorter vehicle descriptions and details",
    icon: <FaFolderPlus size={25} className="mx-auto" />,
  },
  {
    heading: "higher public fees available",
    icon: <RiDiscountPercentFill size={25} className="mx-auto" />,
  },
  {
    heading: "increased risk of purchasing staged vehicles",
    icon: <TiCreditCard size={25} className="mx-auto" />,
  },
];
export const BuyerFeesListCardList = [
  { range: "$0.01 - $49.99", standard: "$25.00" },
  { range: "$50.00 - $99.99", standard: "$45.00" },
  { range: "$100.00 - $199.99", standard: "$80.00" },
  { range: "$200.00 - $399.99", standard: "$135.00" },
  { range: "$400.00 - $499.99", standard: "$180.00" },
  { range: "$500.00 - $599.99", standard: "$205.00" },
  { range: "$600.00 - $699.99", standard: "$235.00" },
  { range: "$700.00 - $799.99", standard: "$260.00" },
  { range: "$800.00 - $899.99", standard: "$280.00" },
  { range: "$900.00 - $999.99", standard: "$305.00" },
  { range: "$1000.00 - $1199.99", standard: "$355.00" },
  { range: "$1200.00 - $1299.99", standard: "$380.00" },
  { range: "$1300.00 - $1399.99", standard: "$400.00" },
  { range: "$1400.00 - $1499.99", standard: "$410.00" },
  { range: "$1500.00 - $1599.99", standard: "$420.00" },
  { range: "$1600.00 - $1699.99", standard: "$440.00" },
  { range: "$1700.00 - $1799.99", standard: "$450.00" },
  { range: "$1800.00 - $1999.99", standard: "$465.00" },
  { range: "$2000.00 - $2399.99", standard: "$500.00" },
  { range: "$2400.00 - $2499.99", standard: "$525.00" },
  { range: "$2500.00 - $2999.99", standard: "$550.00" },
  { range: "$3000.00 - $3499.99", standard: "$650.00" },
  { range: "$3500.00 - $3999.99", standard: "$700.00" },
  { range: "$4000.00 - $4499.99", standard: "$725.00" },
  { range: "$4500.00 - $4999.99", standard: "$750.00" },
  { range: "$5000.00 - $5999.99", standard: "$775.00" },
  { range: "$6000.00 - $7499.99", standard: "$825.00" },
  { range: "$75000.00 - $9999.99", standard: "$850.00" },
  { range: "$10000.00 - $14999.99", standard: "$900.00" },
  { range: "$15000.00+", standard: "7.50%" },
 
];
export const  IAAIdatalist = [
  { range: "$0.00 - $49.99", standard: "$25.00" },
  { range: "$50.00 - $99.99", standard: "$45.00" },
  { range: "$100.00 - $199.99", standard: "$80.00" },
  { range: "$200.00 - $399.99", standard: "$130.00" },
  { range: "$300.00 - $349.99", standard: "$150.00" },
  { range: "$350.00 - $399.99", standard: "$160.00" },
  { range: "$400.00 - $449.99", standard: "$170.00" },
  { range: "$450.00 - $499.99", standard: "$180.00" },
  { range: "$500.00 - $549.99", standard: "$200.00" },
  { range: "$550.00 - $599.99", standard: "$205.00" },
  { range: "$600.00 - $699.99", standard: "$235.00" },
  { range: "$700.00 - $799.99", standard: "$260.00" },
  { range: "$800.00 - $899.99", standard: "$280.00" },
  { range: "$900.00 - $999.99", standard: "$305.00" },
  { range: "$1000.00 - $1199.99", standard: "$355.00" },
  { range: "$1200.00 - $1299.99", standard: "$380.00" },
  { range: "$1300.00 - $1399.99", standard: "$400.00" },
  { range: "$1400.00 - $1499.99", standard: "$410.00" },
  { range: "$1500.00 - $1599.99", standard: "$420.00" },
  { range: "$1600.00 - $1699.99", standard: "$440.00" },
  { range: "$1700.00 - $1799.99", standard: "$450.00" },
  { range: "$1800.00 - $1999.99", standard: "$465.00" },
  { range: "$2000.00 - $2399.99", standard: "$500.00" },
  { range: "$2400.00 - $2499.99", standard: "$525.00" },
  { range: "$2500.00 - $2999.99", standard: "$550.00" },
  { range: "$3000.00 - $3499.99", standard: "$650.00" },
  { range: "$3500.00 - $3999.99", standard: "$700.00" },
  { range: "$4000.00 - $4499.99", standard: "$725.00" },
  { range: "$4500.00 - $4999.99", standard: "$750.00" },
  { range: "$5000.00 - $5999.99", standard: "$775.00" },
  { range: "$6000.00 - $6999.99", standard: "$800.00" },
  { range: "$7000.00 - $7999.99", standard: "$825.00" },
  { range: "$8000.00 - $9999.99", standard: "$850.00" },
  { range: "$10000.00 - $14999.99", standard: "$900.00" },
  { range: "$15000+", standard: "7.50% of sale price " },
 
];
export const VirtualBidFeeCardList = [
  { range: "$0.00 - $99.99", PreBidFee:'-',standard: "-" },
  { range: "$100.00 - $499.99", PreBidFee:'$45.00',standard: "$55.00" },
  { range: "$500.00 - $999.99", PreBidFee:'$60.00',standard: "$70.00" },
  { range: "$1,000.00 - $1,499.99", PreBidFee:'$80.00',standard: "$90.00" },
  { range: "$1,500.00 - $1,999.99", PreBidFee:'$90.00',standard: "$100.00" },
  { range: "$2000.00 - $3999.99", PreBidFee:'$105.00',standard: "$115.00" },
  { range: "$4000.00 - $5999.99", PreBidFee:'$115.00',standard: "$130.00" },
  { range: "$6000.00 - $7999.99", PreBidFee:'$130.00',standard: "$150.00" },
  { range: "$8000.00$+", PreBidFee:'$150.00',standard: "$165.00" },

];
export const internetFeeList = [
  { range: "$0.00 - $99.99", PreBidFee:'$0',standard: "$0" },
  { range: "$100.00 - $499.99", PreBidFee:'$39.00',standard: "$49.00" },
  { range: "$500.00 - $999.99", PreBidFee:'$49.00',standard: "$59.00" },
  { range: "$1,000.00 - $1,499.99", PreBidFee:'$69.00',standard: "$79.00" },
  { range: "$1500.00 - $1999.99", PreBidFee:'$79.00',standard: "$89.00" },
  { range: "$2000.00 - $3999.99", PreBidFee:'$89.00',standard: "$99.00" },
  { range: "$4000.00 - $5999.99", PreBidFee:'$99.00',standard: "$109.00" },
  { range: "$6000.00 - $7999.99", PreBidFee:'$119.00',standard: "$139.00" },
 
  { range: "$8000.00+", PreBidFee:'$129.00',standard: "$149.00" },
  
];
export const UserOrder = [
  {
    // image: car1,
    Gmt: "Chverolet gMT 400",
    location: "From Kansas to Hoston",
    price: "paid:700$",
    date: "Date: 13-03-2024",
    Status: ":Completed",
  },
  {
    // image: car1,
    Gmt: "Chverolet gMT 400",
    location: "From Kansas to Hoston",
    price: "paid:700$",
    date: "Date: 13-03-2024",
    Status: ":Cancelled",
  },
  {
    // image: car1,
    Gmt: "Chverolet gMT 400",
    location: "From Kansas to Hoston",
    price: "paid:700$",
    date: "Date: 13-03-2024",
    Status: ":Completed",
  },
  {
    // image: car1,
    Gmt: "Chverolet gMT 400",
    location: "From Kansas to Hoston",
    price: "paid:700$",
    date: "Date: 13-03-2024",
    Status: ":Shipping",
  },
  {
    // image: car1,
    Gmt: "Chverolet gMT 400",
    location: "From Kansas to Hoston",
    price: "paid:700$",
    date: "Date: 13-03-2024",
    Status: ":Completed",
  },
];

export const keyFeatures = [
  {
    icon: <FaMedal size={25} color="white" />,
    heading: "Quality You Can Trust:",
    para: " Our team of experts handpick each vehicle to meet our rigorous standards. We ensure that every vehicle, from luxury sedans to durable SUVs, is of the highest quality and meets our customers' needs. We offer a curated selection to suit every lifestyle and need.",
  },
  {
    icon: <FaLock size={25} color="white" />,
    heading: "Transparent Pricing, No Surprises:",
    para: "Enjoy 100% upfront pricing with no hidden fees, detailed cost breakdowns, and transparent contracts for complete peace of mind.",
  },
  {
    icon: <BsEyeFill size={25} color="white" />,
    heading: "Effortless Self-Service Platform:",
    para: "Our online auction platform is designed for minimal interaction, empowering you with all the necessary information to bid confidently and secure the right vehicle. From browsing to delivery, the process is seamless, efficient, and tailored to put you in control.",
  },
  {
    icon: <FaPeopleLine size={25} color="white" />,
    heading: "Rooted in Our Community:",
    para: "As a Bahamian-owned business, we take pride in supporting local initiatives and building trust within our community. At BidCaribbean, a Lux First Choice Car Division, you’re not just a client—you’re family.",
  },
  {
    icon: <FaPeopleLine size={25} color="white" />,
    heading: "Seamless Bidding Experience",
    para: " Our user-friendly platform allows you to browse, bid, and buy confidently. Verified and secure, it’s designed to make the process effortless and stress-free.",
  },
  {
    icon: <FaPeopleLine size={25} color="white" />,
    heading: "Comprehensive Vehicle Selection:",
    para: "With access to 300,000+ curated vehicles, we provide options for every budget and requirement, from compact cars to high-performance vehicles.",
  },
  {
    icon: <FaPeopleLine size={25} color="white" />,
    heading: "Flexible Delivery Services:",
    para: "Enjoy the convenience of home delivery or pickup from a designated location, ensuring you get your vehicle on your terms.",
  },
  {
    icon: <FaPeopleLine size={25} color="white" />,
    heading: "Exceptional Customer Support:",
    para: "Our VIP bidding support team is available to guide you through every step of the process, ensuring a seamless and enjoyable experience.",
  },
];


